import React, { useState } from "react";
import { Anchor, Toc, Type } from "discover.medical.react-component-library";
import { Link } from "react-router-dom";
import {
  logBrowseGroupExpanded,
  logBrowseTopicClicked,
} from "../../../../util/analytics";

const DetailsListItem = ({
  level = 0,
  detailsToRender,
  telemetryData,
  sharedTelemetryData,
}) => {
  const [isExpanded, setExpanded] = useState(false);

  const handleItemClick = (sharedTelemetryData, path, sectionTitle) => {
    const telemetry = {
      ...sharedTelemetryData,
      path,
      sectionTitle,
    };
    logBrowseGroupExpanded(telemetry);
    setExpanded(!isExpanded);
  };

  const handleTopicClick = (sharedTelemetryData, telemetryData) => {
    const telemetry = {
      ...telemetryData,
      categoryId: sharedTelemetryData.categoryId,
      isFollowing: sharedTelemetryData.isFollowing,
      browseType: sharedTelemetryData.browseType,
    };
    logBrowseTopicClicked(telemetry);
  };

  const { subSpecialties = [], contentLinks = [], label } = detailsToRender;
  const hasChildrenNodes =
    subSpecialties?.length > 0 || contentLinks?.length > 0;

  const linksMap = (contentLinks, nextLevel) => {
    return contentLinks.map((link) => (
      <Toc.Title
        anchor={
          <Anchor
            href={link.route}
            linkComponent={Link}
            onClick={() =>
              handleTopicClick(sharedTelemetryData, link.telemetryData)
            }
          >
            {link.label}
          </Anchor>
        }
        currentLevel={nextLevel ? level + 1 : level}
      />
    ));
  };

  if (!label && contentLinks?.length > 0) {
    return (
      <Toc.ListItem data-testid="specialty-details-item">
        {linksMap(contentLinks)}
      </Toc.ListItem>
    );
  } else {
    return (
      <Toc.ListItem data-testid="specialty-details-item">
        <Toc.Title
          isAnchor={!hasChildrenNodes}
          isOpen={isExpanded}
          currentLevel={level}
          onClick={() =>
            handleItemClick(
              sharedTelemetryData,
              telemetryData?.path,
              telemetryData?.sectionTitle
            )
          }
          icon={hasChildrenNodes && <Toc.Icon isOpen={isExpanded} />}
        >
          <Type fontSize="md">{label}</Type>
        </Toc.Title>
        {isExpanded &&
          subSpecialties?.length > 0 &&
          subSpecialties.map((subSpecialty) => (
            <DetailsListItem
              level={level + 1}
              detailsToRender={subSpecialty}
              telemetryData={subSpecialty.telemetryData}
              sharedTelemetryData={sharedTelemetryData}
            />
          ))}
        {isExpanded && contentLinks?.length > 0 && linksMap(contentLinks, true)}
      </Toc.ListItem>
    );
  }
};

DetailsListItem.displayName = "DetailsListItem";

export default DetailsListItem;
